import { createFileRoute } from "@tanstack/react-router";
import { ApprovalsPage, approvalsSearchSchema } from "@/features/approvals/approvals-page";

export const Route = createFileRoute("/_app/approvals")({
  validateSearch: approvalsSearchSchema,
  head: () => ({ meta: [{ title: "Approvals · Malfak" }] }),
  component: ApprovalsRoute,
});

function ApprovalsRoute() {
  const search = Route.useSearch();
  return <ApprovalsPage search={search} />;
}
